//接口
//引入axios 
import request from './request' // 这里是引入咱们的axios用axios来进行异步接口请求

//比如说接口为注册接口
export function register(data) {
	return request({
		url: '/m/register',
		method: 'post',
		data,
	})
}
export function sendmsg(data) {
	return request({
		url: '/m/sendmsg',
		method: 'post',
		data,
	})
}
export function registerBankList(params) {
	return request({
		url: '/m/register_bank_list',
		method: 'get',
		params,
	})
}
export function login(data) {
	return request({
		url: '/m/login',
		method: 'post',
		data,
	})
}

export function resetloginpassword(data) {
	return request({
		url: '/m/reset_loginpassword',
		method: 'post',
		data,
	})
}

export function resetloginpasswordNologin(data) {
	return request({
		url: '/m/reset_loginpassword_nologin',
		method: 'post',
		data,
	})
}

export function resetqkpassword(data) {
	return request({
		url: '/m/reset_qkpassword',
		method: 'post',
		data,
	})
}

export function qkpsdbind(data) {
	return request({
		url: '/m/qkpassword_bind',
		method: 'post',
		data,
	})
}

export function userinfo(data) {
	return request({
		url: '/m/new_userinfo',
		method: 'post',
		data,
	})
}
export function levels(data) {
	return request({
		url: '/m/levels',
		method: 'post',
		data,
	})
}
export function inviteinfo(data) {
	return request({
		url: '/m/inviteinfo',
		method: 'post',
		data,
	})
}
export function rechargetype(params) {
	return request({
		url: '/m/recharge_type',
		method: 'get',
		params,
	})
}
export function about() {
	return request({
		url: '/m/about',
		method: 'get',
	})
}
export function drawingsubmit(data) {
	return request({
		url: '/m/drawing_submit',
		method: 'post',
		data,
	})
}

export function fanlitype(params) {
	return request({
		url: '/m/fanli_type',
		method: 'get',
		params,
	})
}

export function recharge(data) {
	return request({
		url: '/m/recharge_submit',
		method: 'post',
		data,
		timeout: 10000,
	})
}
export function activityList(data) {
	return request({
		url: '/m/new_activity_list?page=' + data.page,
		method: 'get',
		data,
	})
}
export function activityDetail(data) {
	return request({
		url: '/m/new_activity_detail?id=' + data.id,
		method: 'get',
		data,
	})
}
export function aboutDetail(data) {
	return request({
		url: '/m/about_detail?id=' + data.id,
		method: 'get',
		data,
	})
}
export function noticeList(data) {
	return request({
		url: '/m/new_notice_list',
		method: 'get',
		data,
	})
}
export function noticeDetalis(data) {
	return request({
		url: '/m/new_notice_detail?id=' + data.id,
		method: 'get',
		data,
	})
}
export function newbindbank(data) {
	return request({
		url: '/m/new_bind_bank',
		method: 'post',
		data,
	})
}
export function deletebank(data) {
	return request({
		url: '/m/delete_bank',
		method: 'post',
		data,
	})
}
export function banklist(params) {
	return request({
		url: '/m/bank_list',
		method: 'get',
		params,
	})
}
export function mywallets(data) {
	return request({
		url: '/m/mywallet',
		method: 'get',
		data,
	})
}
export function rechargelist(params) {
	return request({
		url: '/m/recharge_list',
		method: 'get',
		params,
	})
}
export function drawinglist(params) {
	return request({
		url: '/m/drawing_list',
		method: 'get',
		params,
	})
}
export function fslist(params) {
	return request({
		url: '/m/fs_list',
		method: 'get',
		params,
	})
}
export function modifyBrithday(data) {
	return request({
		url: '/m/bind_birthday',
		method: 'post',
		data,
	})
}
export function getBrithday(data) {
	return request({
		url: '/m/fs_list',
		method: 'get',
		data,
	})
}
export function getsystemconfig(data) {
	return request({
		url: '/m/new_system_config',
		method: 'get',
		data,
	})
}
export function gettongji(params) {
	return request({
		url: '/m/new_tongji',
		method: 'get',
		params,
	})
}
export function getgamelist(params) {
	return request({
		url: '/m/new_game_list',
		method: 'get',
		params,
	})
}
export function getPlatformGamelist(params) {
	return request({
		url: '/game/gamelist',
		method: 'get',
		params,
	})
}
export function getgamerecordlist(params) {
	return request({
		url: '/m/new_game_record_list',
		method: 'get',
		params,
	})
}
export function getgamerecordlist2(params) {
	return request({
		url: '/m/new_game_record_list2',
		method: 'get',
		params,
	})
}
export function youhuilist(params) {
	return request({
		url: '/m/youhui_record',
		method: 'get',
		params,
	})
}
export function shoudonglist(params) {
	return request({
		url: '/m/shoudong_record',
		method: 'get',
		params,
	})
}
export function playGame(data) {
	let url = '/game/playGame?api_code=' + data.api_code + '&game_type=' + data.game_type + '&token=' + data
		.token + '&game_id=' + data.game_id
	if (data.rate != null && data.rate !== '' && Number(data.rate) > 0) {
		url += '&rate=' + encodeURIComponent(data.rate)
	}
	return request({
		url,
		method: 'get',
		data,
	})
}

export function getGamePlayHistory(params) {
	return request({
		url: '/m/play_history',
		method: 'get',
		params,
	})
}

export function saveGamePlayHistory(data) {
	return request({
		url: '/m/play_history',
		method: 'post',
		data,
	})
}

export function qiandaoTianshuList(data) {
	return request({
		url: '/m/qiandao_tianshu_list',
		method: 'get',
		data,
	})
}
export function qiandao(data) {
	return request({
		url: '/m/qiandao',
		method: 'post',
		data,
	})
}
export function chongzhilian(data) {
	return request({
		url: '/m/chongzhilian',
		method: 'post',
		data,
	})
}
export function renwuList(data) {
	return request({
		url: '/m/renwu_list',
		method: 'post',
		data,
	})
}
export function renwuSubmit(data) {
	return request({
		url: '/m/renwu_submit',
		method: 'post',
		data,
	})
}
export function renwuTypeSubmit(data) {
	return request({
		url: '/m/renwu_type_submit',
		method: 'post',
		data,
	})
}

// export function login(){
//     return request({
//         url:'/m/login',
//         method:'get',
//         params,   //一般get请求，我们习惯使用params属性来传参

//     })
// }

//以上为案例


export function turn(data) {
	return request({
		url: '/m/zhuanpan',
		method: 'get',
		data,
	})
}

/** 当日充值档位剩余转盘次数 */
export function turnRemain(params) {
	return request({
		url: '/m/zhuanpan_get',
		method: 'get',
		params,
	})
}

export function turnGo(data) {
	return request({
		url: '/m/zhuan',
		method: 'get',
		data,
	})
}
export function hongbao(data) {
	return request({
		url: '/m/hongbao',
		method: 'get',
		data,
	})
}

export function hongbaodo(data) {
	return request({
		url: '/m/hongbaodo',
		method: 'get',
		data,
	})
}
export function turn_record(data) {
	return request({
		url: "/m/zhuanpan_record",
		method: "get",
		data
	})
}
export function transferAll(data) {
	return request({
		url: '/member/transfer_all',
		method: 'post',
		data,
	})
}
export function transferAllv2(data) {
	return request({
		url: '/member/post_transfer_v2',
		method: 'post',
		data,
	})
}
export function fsnow(data) {
	return request({
		url: '/m/fs_now',
		method: 'post',
		data,
	})
}
export function levelnow(data) {
	return request({
		url: '/m/levelnow',
		method: 'post',
		data,
	})
}
export function yjnow(data) {
	return request({
		url: '/m/yj_now',
		method: 'post',
		data,
	})
}
export function newRechargeActivity(data) {
	return request({
		url: '/m/new_recharge_activity?type='+data.type,
		method: 'get',
		data,
	})
}
export function check(data) {
	return request({
		url: '/m/check?api_id='+data.api_id,
		method: 'get',
		data,
	})
}

export function yuebaoInfo(data) {
	return request({
		url: '/m/yuebao_info',
		method: 'post',
		data,
	})
}
export function yuebaoRecord(params) {
	return request({
		url: '/m/yuebao_record',
		method: 'get',
		params,
	})
}
export function yuebaoTransferIn(data) {
	return request({
		url: '/m/yuebao_in',
		method: 'post',
		data,
	})
}
export function yuebaoTransferOut(data) {
	return request({
		url: '/m/yuebao_out',
		method: 'post',
		data,
	})
}
export function yuebaoClaim(data) {
	return request({
		url: '/m/yuebao_receive',
		method: 'post',
		data,
	})
}

export function bonusTaskList(params) {
	return request({
		url: '/m/bonus_task_list',
		method: 'get',
		params,
	})
}
export function bonusTaskDetail(params) {
	return request({
		url: '/m/bonus_task_detail',
		method: 'get',
		params,
	})
}
export function bonusTaskClaim(data) {
	return request({
		url: '/m/bonus_task_claim',
		method: 'post',
		data,
	})
}
export function bonusTaskSetPriority(data) {
	return request({
		url: '/m/bonus_task_set_priority',
		method: 'post',
		data,
	})
}
export function lossMoneyInfo(params) {
	return request({
		url: '/m/loss_money_info',
		method: 'get',
		params,
	})
}
export function lossMoneyClaim(data) {
	return request({
		url: '/m/loss_money_claim',
		method: 'post',
		data,
	})
}
export function lossMoneyList(params) {
	return request({
		url: '/m/loss_money_list',
		method: 'get',
		params,
	})
}